// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trf-is-borderless {\n  border: 0 none !important;\n  outline: 0 none !important;\n}", ""]);
// Exports
module.exports = exports;
